export enum WieldMode {
    RIGHT_HAND_WIELD = 0,
    LEFT_HAND_WIELD = 1,
    DUAL_WIELD = 2,
    TWO_HAND_WIELD = 3,
}

export class WieldModeUtils {
    public static coerce(val: string | number | WieldMode): WieldMode {
        if (typeof val === "string") {
            switch (val.trim().toUpperCase()) {
                case "RIGHT":
                case "RIGHT HAND":
                case "0":
                    return WieldMode.RIGHT_HAND_WIELD;
                case "LEFT":
                case "LEFT HAND":
                case "1":
                    return WieldMode.LEFT_HAND_WIELD;
                case "DUAL":
                case "DUAL WIELD":
                case "2":
                    return WieldMode.DUAL_WIELD;
                case "TWO HAND":
                case "TWO-HANDED":
                case "3":
                    return WieldMode.TWO_HAND_WIELD;
                default:
                    return WieldMode.RIGHT_HAND_WIELD;
            }
        } else if (typeof val === "number") {
            return Object.values(WieldMode).includes(val)
                ? val
                : WieldMode.RIGHT_HAND_WIELD;
        } else {
            return val;
        }
    }

    public static getLabel(val: string | number | WieldMode): string {
        const coercedValue =
            typeof val === "string" || typeof val === "number"
                ? this.coerce(val)
                : val;
        switch (coercedValue) {
            case WieldMode.RIGHT_HAND_WIELD:
                return "Right Hand";
            case WieldMode.LEFT_HAND_WIELD:
                return "Left Hand";
            case WieldMode.DUAL_WIELD:
                return "Dual Wield";
            case WieldMode.TWO_HAND_WIELD:
                return "Two-Handed";
            default:
                return "Unknown";
        }
    }
}
